import { render, staticRenderFns } from "./UnmatchedProjects.vue?vue&type=template&id=e85f8b0c"
import script from "./UnmatchedProjects.vue?vue&type=script&lang=js"
export * from "./UnmatchedProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports